export interface Recipe {
    id: string;
    title: string;
    description: string;
    prepTime: string;
    cookTime: string;
    imageUrl?: string;
    servings: string;
    date: string;
    ingredients: string[];
    instructions: string[];
}

export const recipeDatabase: Record<string, Recipe[]> = {
    "Cookies & Bars": [
        {
            id: 'cookie-chocolate-chip',
            title: 'Classic Chocolate Chip Cookies',
            description: 'The ultimate chewy and soft chocolate chip cookie.',
            prepTime: '20 min',
            cookTime: '12 min',
            servings: '24 cookies',
            date: 'December 1, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0593.JPG',
            ingredients: [
                '2 1/4 cups (270g) All-Purpose Flour',
                '1 tsp Baking Soda',
                '1 tsp Salt',
                '1 cup (227g) Unsalted Butter, softened',
                '3/4 cup (150g) Granulated Sugar',
                '3/4 cup (165g) Brown Sugar, packed',
                '2 large Eggs',
                '2 tsp Vanilla Extract',
                '2 cups (340g) Semi-Sweet Chocolate Chips'
            ],
            instructions: [
                'Preheat oven to 375°F (190°C).',
                'Whisk together flour, baking soda, and salt.',
                'Cream butter and sugars until light and fluffy.',
                'Beat in eggs one at a time, then stir in vanilla.',
                'Gradually add dry ingredients to wet ingredients.',
                'Stir in chocolate chips.',
                'Drop by rounded tablespoons onto ungreased baking sheets.',
                'Bake for 10-12 minutes or until golden brown.'
            ]
        },
        {
            id: 'cookie-oatmeal-raisin',
            title: 'Chewy Oatmeal Raisin Cookies',
            description: 'A comforting classic, perfectly spiced and chewy.',
            prepTime: '15 min',
            cookTime: '15 min',
            servings: '30 cookies',
            date: 'December 2, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '1 1/2 cups (180g) All-Purpose Flour',
                '1 tsp Baking Soda',
                '1 tsp Cinnamon',
                '1/2 tsp Salt',
                '1 cup (227g) Unsalted Butter, softened',
                '1 cup (220g) Brown Sugar, packed',
                '1/2 cup (100g) Granulated Sugar',
                '2 large Eggs',
                '1 tsp Vanilla Extract',
                '3 cups (240g) Rolled Oats',
                '1 cup (150g) Raisins'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C).',
                'Combine flour, baking soda, cinnamon, and salt.',
                'Cream butter and sugars. Beat in eggs and vanilla.',
                'Gradually add flour mixture. Stir in oats and raisins.',
                'Drop onto baking sheets and bake for 12-15 minutes.'
            ]
        },
        {
            id: 'bar-fudgy-brownies',
            title: 'Ultimate Fudgy Brownies',
            description: 'Rich, dense, and intensely chocolatey brownies with a crinkly top.',
            prepTime: '15 min',
            cookTime: '30 min',
            servings: '16 brownies',
            date: 'December 3, 2025',
            imageUrl: '/images/blog/chocolate-cake.png',
            ingredients: [
                '1/2 cup (113g) Unsalted Butter, melted',
                '1 cup (200g) Granulated Sugar',
                '2 large Eggs',
                '1 tsp Vanilla Extract',
                '1/2 cup (60g) All-Purpose Flour',
                '1/2 cup (45g) Unsweetened Cocoa Powder',
                '1/4 tsp Baking Powder',
                '1/4 tsp Salt',
                '1/2 cup (85g) Chocolate Chips'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease an 8x8 inch pan.',
                'Combine melted butter, sugar, eggs, and vanilla.',
                'In a separate bowl, whisk flour, cocoa powder, baking powder, and salt.',
                'Gently fold dry ingredients into wet ingredients until just combined.',
                'Stir in chocolate chips. Pour into prepared pan.',
                'Bake for 25-30 minutes. Let cool completely before cutting.'
            ]
        },
        {
            id: 'cookie-snickerdoodle',
            title: 'Soft Snickerdoodles',
            description: 'Classic tangy and chewy cookies rolled in cinnamon-sugar.',
            prepTime: '15 min',
            cookTime: '10 min',
            servings: '36 cookies',
            date: 'December 4, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '2 3/4 cups (330g) All-Purpose Flour',
                '2 tsp Cream of Tartar',
                '1 tsp Baking Soda',
                '1/2 tsp Salt',
                '1 cup (227g) Unsalted Butter, softened',
                '1 1/2 cups (300g) Granulated Sugar',
                '2 large Eggs',
                'Topping: 1/4 cup Sugar, 2 tbsp Cinnamon'
            ],
            instructions: [
                'Preheat oven to 400°F (200°C).',
                'Whisk flour, cream of tartar, baking soda, and salt.',
                'Cream butter and sugar. Beat in eggs.',
                'Combine wet and dry ingredients. Chill dough for 30 minutes.',
                'Mix topping ingredients. Roll dough into balls and coat in cinnamon-sugar.',
                'Bake for 8-10 minutes.'
            ]
        },
        {
            id: 'cookie-peanut-butter',
            title: 'Classic Peanut Butter Cookies',
            description: 'Simple, soft, and crumbly cookies with the iconic fork pattern.',
            prepTime: '10 min',
            cookTime: '12 min',
            servings: '24 cookies',
            date: 'December 5, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '1/2 cup (113g) Unsalted Butter, softened',
                '1/2 cup (125g) Creamy Peanut Butter',
                '1/2 cup (100g) Granulated Sugar',
                '1/2 cup (110g) Brown Sugar, packed',
                '1 large Egg',
                '1 1/4 cups (150g) All-Purpose Flour',
                '3/4 tsp Baking Soda',
                '1/2 tsp Baking Powder'
            ],
            instructions: [
                'Preheat oven to 375°F (190°C).',
                'Cream butter, peanut butter, and sugars. Beat in egg.',
                'Whisk dry ingredients and add to wet mixture.',
                'Roll into balls, place on baking sheet, and press with a fork in a crisscross pattern.',
                'Bake for 10-12 minutes.'
            ]
        },
        {
            id: 'cookie-shortbread',
            title: 'Buttery Shortbread Cookies',
            description: 'Melt-in-your-mouth cookies with just three ingredients.',
            prepTime: '10 min',
            cookTime: '20 min',
            servings: '16 cookies',
            date: 'December 6, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '1 cup (227g) Unsalted Butter, softened',
                '1/2 cup (60g) Powdered Sugar',
                '2 cups (240g) All-Purpose Flour',
                '1/4 tsp Salt'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C).',
                'Cream butter and powdered sugar until smooth.',
                'Gradually add flour and salt, mixing until just combined.',
                'Press dough into an 8x8 inch pan or roll and cut into shapes.',
                'Bake for 18-20 minutes, until edges are lightly golden.'
            ]
        },
        {
            id: 'bar-lemon',
            title: 'Tangy Lemon Bars',
            description: 'A sweet and tangy lemon filling on a buttery shortbread crust.',
            prepTime: '20 min',
            cookTime: '40 min',
            servings: '16 bars',
            date: 'December 7, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                'Crust: 1 cup (227g) Butter, 1/2 cup (60g) Powdered Sugar, 2 cups (240g) Flour',
                'Filling: 4 large Eggs, 1 1/2 cups (300g) Sugar, 1/4 cup (30g) Flour, 1 cup (240ml) Fresh Lemon Juice'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C).',
                'For crust, combine ingredients and press into a 9x13 inch pan. Bake for 20 minutes.',
                'For filling, whisk all ingredients together until smooth.',
                'Pour filling over hot crust and bake for another 20-25 minutes, until set.',
                'Let cool completely and dust with powdered sugar.'
            ]
        },
        {
            id: 'bar-rice-krispie',
            title: 'Gooey Rice Krispie Treats',
            description: 'The classic no-bake treat, made extra gooey and delicious.',
            prepTime: '10 min',
            cookTime: '5 min',
            servings: '12 treats',
            date: 'December 8, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '6 cups Rice Krispies Cereal',
                '1 (10 oz) package Marshmallows',
                '1/4 cup (57g) Unsalted Butter'
            ],
            instructions: [
                'Grease a 9x13 inch pan.',
                'In a large pot, melt butter over low heat. Add marshmallows and stir until completely melted.',
                'Remove from heat and stir in Rice Krispies cereal until well coated.',
                'Press mixture evenly into the prepared pan. Let cool before cutting.'
            ]
        },
        {
            id: 'cookie-macadamia-nut',
            title: 'White Chocolate Macadamia Nut Cookies',
            description: 'Soft and chewy cookies loaded with white chocolate chips and macadamia nuts.',
            prepTime: '20 min',
            cookTime: '12 min',
            servings: '24 cookies',
            date: 'December 9, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0593.JPG',
            ingredients: [
                '2 1/4 cups (270g) All-Purpose Flour',
                '1 tsp Baking Soda',
                '1/2 tsp Salt',
                '1 cup (227g) Unsalted Butter, softened',
                '3/4 cup (150g) Granulated Sugar',
                '1/2 cup (110g) Brown Sugar, packed',
                '2 large Eggs',
                '1 tsp Vanilla Extract',
                '1 1/2 cups (255g) White Chocolate Chips',
                '1 cup (130g) Macadamia Nuts, chopped'
            ],
            instructions: [
                'Preheat oven to 375°F (190°C).',
                'Whisk together flour, baking soda, and salt.',
                'Cream butter and sugars until light and fluffy.',
                'Beat in eggs one at a time, then stir in vanilla.',
                'Gradually add dry ingredients to wet ingredients.',
                'Stir in white chocolate chips and macadamia nuts.',
                'Drop by rounded tablespoons onto baking sheets.',
                'Bake for 10-12 minutes until edges are golden.'
            ]
        },
        {
            id: 'cookie-gingerbread',
            title: 'Gingerbread Cookies',
            description: 'Classic spiced gingerbread cookies, perfect for decorating during the holidays.',
            prepTime: '20 min',
            cookTime: '10 min',
            servings: '36 cookies',
            date: 'December 10, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '3 cups (360g) All-Purpose Flour',
                '2 tsp Ground Ginger',
                '1 tsp Ground Cinnamon',
                '1/4 tsp Ground Cloves',
                '1/4 tsp Salt',
                '3/4 cup (170g) Unsalted Butter, softened',
                '1/2 cup (110g) Brown Sugar, packed',
                '1/2 cup (170g) Molasses',
                '1 large Egg'
            ],
            instructions: [
                'Whisk together flour and spices.',
                'Cream butter and brown sugar. Beat in molasses and egg.',
                'Gradually add dry ingredients to wet mixture. Mix until a dough forms.',
                'Divide dough in half, wrap in plastic, and chill for at least 2 hours.',
                'Preheat oven to 350°F (175°C).',
                'Roll out dough and cut into shapes.',
                'Bake for 8-10 minutes. Let cool before decorating.'
            ]
        },
        {
            id: 'bar-blondies',
            title: 'Chewy Blondies',
            description: 'A buttery, brown sugar-based bar with a chewy texture, like a brownie without the chocolate.',
            prepTime: '15 min',
            cookTime: '25 min',
            servings: '16 bars',
            date: 'December 1, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1/2 cup (113g) Unsalted Butter, melted',
                '1 cup (220g) Brown Sugar, packed',
                '1 large Egg',
                '1 tsp Vanilla Extract',
                '1 cup (120g) All-Purpose Flour',
                '1/2 tsp Baking Powder',
                '1/4 tsp Salt',
                '1 cup (170g) Chocolate Chips or Nuts (optional)'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease an 8x8 inch pan.',
                'Whisk melted butter and brown sugar. Add egg and vanilla.',
                'In a separate bowl, combine flour, baking powder, and salt.',
                'Fold dry ingredients into wet ingredients until just combined.',
                'Stir in optional add-ins. Pour into prepared pan.',
                'Bake for 22-25 minutes. The center should be slightly gooey.'
            ]
        },
        {
            id: 'cookie-biscotti',
            title: 'Almond Biscotti',
            description: 'Classic Italian twice-baked cookies, perfect for dipping in coffee.',
            prepTime: '20 min',
            cookTime: '40 min',
            servings: '24 biscotti',
            date: 'December 2, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '2 cups (240g) All-Purpose Flour',
                '1 cup (200g) Granulated Sugar',
                '1 tsp Baking Powder',
                '1/4 tsp Salt',
                '2 large Eggs',
                '1 tsp Almond Extract',
                '1 cup (140g) Whole Almonds, toasted'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C).',
                'Whisk together flour, sugar, baking powder, and salt.',
                'In another bowl, whisk eggs and almond extract. Add to dry ingredients and mix to form a sticky dough.',
                'Fold in the almonds.',
                'On a floured surface, divide dough in two and shape each half into a flattened log.',
                'Bake for 25 minutes. Let cool for 10 minutes.',
                'Slice the logs diagonally into 1/2-inch thick slices.',
                'Place slices cut-side down on the baking sheet and bake for another 8-10 minutes per side, until golden and crisp.'
            ]
        }
    ],
    "Cakes & Cupcakes": [
        {
            id: 'cake-vanilla',
            title: 'Classic Vanilla Cake',
            description: 'A moist, fluffy, and versatile vanilla cake for any occasion.',
            prepTime: '20 min',
            cookTime: '35 min',
            servings: '12 servings',
            date: 'December 3, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0661.JPG',
            ingredients: [
                '2 1/2 cups (300g) All-Purpose Flour',
                '2 1/2 tsp Baking Powder',
                '1/2 tsp Salt',
                '3/4 cup (170g) Unsalted Butter, softened',
                '1 1/2 cups (300g) Granulated Sugar',
                '3 large Eggs',
                '2 tsp Vanilla Extract',
                '1 1/4 cups (300ml) Milk'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease and flour two 9-inch round cake pans.',
                'Whisk flour, baking powder, and salt.',
                'Cream butter and sugar. Beat in eggs one at a time, then vanilla.',
                'Alternate adding flour mixture and milk, beginning and ending with flour.',
                'Divide batter between pans and bake for 30-35 minutes.'
            ]
        },
        {
            id: 'cake-chocolate',
            title: 'Ultimate Chocolate Cake',
            description: 'A rich, moist, and deeply chocolatey cake.',
            prepTime: '20 min',
            cookTime: '40 min',
            servings: '12 servings',
            date: 'December 4, 2025',
            imageUrl: 'https://sweetysbakery.com/images/BROWNIE%201.JPG',
            ingredients: [
                '2 cups (400g) Sugar',
                '1 3/4 cups (210g) All-Purpose Flour',
                '3/4 cup (65g) Unsweetened Cocoa Powder',
                '1 1/2 tsp Baking Powder',
                '1 1/2 tsp Baking Soda',
                '1 tsp Salt',
                '2 large Eggs',
                '1 cup (240ml) Milk',
                '1/2 cup (120ml) Vegetable Oil',
                '2 tsp Vanilla Extract',
                '1 cup (240ml) Boiling Water'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease and flour two 9-inch round pans.',
                'Whisk together all dry ingredients in a large bowl.',
                'Add eggs, milk, oil, and vanilla. Beat on medium speed for 2 minutes.',
                'Carefully stir in boiling water (batter will be thin).',
                'Pour into pans and bake for 35-40 minutes.'
            ]
        },
        {
            id: 'cake-red-velvet',
            title: 'Classic Red Velvet Cake',
            description: 'A Southern classic with a tender crumb and a hint of cocoa.',
            prepTime: '25 min',
            cookTime: '30 min',
            servings: '12 servings',
            date: 'December 5, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0668.JPG',
            ingredients: [
                '2 1/2 cups (300g) All-Purpose Flour',
                '1 1/2 cups (300g) Sugar',
                '1 tsp Baking Soda',
                '1 tsp Cocoa Powder',
                '1/2 tsp Salt',
                '2 large Eggs',
                '1 1/2 cups (360ml) Vegetable Oil',
                '1 cup (240ml) Buttermilk',
                '1 tbsp Red Food Coloring',
                '1 tsp Vanilla Extract',
                '1 tsp White Vinegar'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease and flour two 9-inch pans.',
                'Whisk dry ingredients. In another bowl, whisk eggs, oil, buttermilk, food coloring, vanilla, and vinegar.',
                'Combine wet and dry ingredients. Do not overmix.',
                'Pour into pans and bake for 30 minutes.'
            ]
        },
        {
            id: 'cake-carrot',
            title: 'Moist Carrot Cake',
            description: 'Perfectly spiced and incredibly moist, topped with cream cheese frosting.',
            prepTime: '25 min',
            cookTime: '45 min',
            servings: '12 servings',
            date: 'December 6, 2025',
            imageUrl: 'https://sweetysbakery.com/images/Caramel%20Cake%20mom%20pirthday.JPG',
            ingredients: [
                '2 cups (240g) All-Purpose Flour',
                '2 tsp Baking Soda',
                '1/2 tsp Salt',
                '2 tsp Cinnamon',
                '1 1/2 cups (300g) Sugar',
                '1 1/4 cups (300ml) Vegetable Oil',
                '4 large Eggs',
                '3 cups (300g) Grated Carrots'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease and flour a 9x13 inch pan.',
                'Whisk flour, baking soda, salt, and cinnamon.',
                'In a separate bowl, beat sugar, oil, and eggs.',
                'Combine wet and dry ingredients, then fold in carrots.',
                'Pour into pan and bake for 40-50 minutes.'
            ]
        },
        {
            id: 'cake-cheesecake',
            title: 'New York Cheesecake',
            description: 'A rich, dense, and creamy cheesecake with a graham cracker crust.',
            prepTime: '30 min',
            cookTime: '1 hr 15 min',
            servings: '16 servings',
            date: 'December 7, 2025',
            imageUrl: 'https://sweetysbakery.com/images/flan%20venzouela.jpeg',
            ingredients: [
                'Crust: 1 1/2 cups Graham Cracker Crumbs, 1/4 cup Sugar, 6 tbsp Melted Butter',
                'Filling: 32 oz (4 blocks) Cream Cheese, softened',
                '1 1/4 cups (250g) Sugar',
                '1/2 cup (120ml) Sour Cream',
                '2 tsp Vanilla Extract',
                '4 large Eggs'
            ],
            instructions: [
                'Preheat oven to 325°F (165°C).',
                'Combine crust ingredients and press into the bottom of a 9-inch springform pan.',
                'Beat cream cheese and sugar until smooth. Mix in sour cream and vanilla.',
                'Add eggs one at a time, mixing on low speed until just combined.',
                'Pour filling over crust. Bake in a water bath for 75 minutes.',
                'Turn off oven and let cheesecake cool in the oven with the door cracked for 1 hour. Chill for at least 4 hours.'
            ]
        },
        {
            id: 'cake-pound',
            title: 'Classic Pound Cake',
            description: 'A dense, moist, and buttery cake with a fine crumb.',
            prepTime: '20 min',
            cookTime: '1 hr 10 min',
            servings: '12 servings',
            date: 'December 8, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0872.JPG',
            ingredients: [
                '1 cup (227g) Unsalted Butter, softened',
                '2 cups (400g) Sugar',
                '4 large Eggs',
                '3 cups (360g) All-Purpose Flour',
                '1/2 tsp Baking Powder',
                '1/2 tsp Salt',
                '1 cup (240ml) Milk',
                '1 tsp Vanilla Extract'
            ],
            instructions: [
                'Preheat oven to 325°F (165°C). Grease and flour a loaf or bundt pan.',
                'Cream butter and sugar for 5-7 minutes until very light and fluffy.',
                'Add eggs one at a time.',
                'Whisk dry ingredients. In a separate bowl, combine milk and vanilla.',
                'Alternate adding dry and wet ingredients to the creamed mixture.',
                'Bake for 60-70 minutes, until a skewer comes out clean.'
            ]
        },
        {
            id: 'cupcake-vanilla',
            title: 'Perfect Vanilla Cupcakes',
            description: 'Light, fluffy, and moist vanilla cupcakes.',
            prepTime: '15 min',
            cookTime: '20 min',
            servings: '12 cupcakes',
            date: 'December 9, 2025',
            imageUrl: 'https://sweetysbakery.com/images/CUP%20CAKES.JPG',
            ingredients: [
                '1 1/2 cups (180g) All-Purpose Flour',
                '1 1/2 tsp Baking Powder',
                '1/4 tsp Salt',
                '1/2 cup (113g) Unsalted Butter, softened',
                '1 cup (200g) Sugar',
                '2 large Eggs',
                '1 tsp Vanilla Extract',
                '1/2 cup (120ml) Milk'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Line a muffin tin with cupcake liners.',
                'Whisk flour, baking powder, and salt.',
                'Cream butter and sugar. Beat in eggs and vanilla.',
                'Alternate adding dry ingredients and milk.',
                'Fill liners 2/3 full and bake for 18-20 minutes.'
            ]
        },
        {
            id: 'cake-angel-food',
            title: 'Angel Food Cake',
            description: 'An incredibly light and airy sponge cake made with only egg whites, no fat.',
            prepTime: '25 min',
            cookTime: '45 min',
            servings: '12 servings',
            date: 'December 10, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0650.JPG',
            ingredients: [
                '1 1/2 cups (300g) Granulated Sugar, divided',
                '1 cup (120g) Cake Flour',
                '1/4 tsp Salt',
                '12 large Egg Whites, room temperature',
                '1 1/2 tsp Cream of Tartar',
                '1 tsp Vanilla Extract'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Do not grease the tube pan.',
                'Sift together 3/4 cup of sugar, cake flour, and salt. Repeat sifting 3-4 times.',
                'In a large, clean bowl, beat egg whites and cream of tartar until foamy.',
                'Gradually add the remaining 3/4 cup of sugar, beating until stiff, glossy peaks form.',
                'Beat in vanilla extract.',
                'Gently fold the flour mixture into the meringue in three additions.',
                'Pour batter into an ungreased tube pan. Bake for 40-45 minutes.',
                'Invert the pan to cool completely before removing the cake.'
            ]
        },
        {
            id: 'cake-black-forest',
            title: 'Black Forest Cake',
            description: 'A classic German dessert with layers of chocolate sponge, whipped cream, and cherries.',
            prepTime: '45 min',
            cookTime: '35 min',
            servings: '12 servings',
            date: 'December 1, 2025',
            imageUrl: 'https://sweetysbakery.com/images/CAKE%20DESIGN%202.JPG',
            ingredients: [
                '1 recipe Ultimate Chocolate Cake',
                '1 (21 oz) can Cherry Pie Filling',
                '1/4 cup Kirsch (cherry brandy), optional',
                '3 cups Heavy Whipping Cream',
                '1/2 cup Powdered Sugar',
                'Chocolate Shavings for decoration'
            ],
            instructions: [
                'Bake the chocolate cake and let it cool completely. Split layers if necessary.',
                'If using, stir Kirsch into the cherry pie filling.',
                'Whip heavy cream and powdered sugar until stiff peaks form.',
                'Assemble the cake: Place one layer on a plate. Top with a layer of whipped cream and then a layer of cherry filling.',
                'Repeat with remaining layers.',
                'Frost the outside of the cake with whipped cream and decorate with chocolate shavings and whole cherries.'
            ]
        },
        {
            id: 'cake-coffee',
            title: 'Cinnamon Streusel Coffee Cake',
            description: 'A moist, buttery cake with a thick layer of cinnamon-sugar streusel in the middle and on top.',
            prepTime: '20 min',
            cookTime: '45 min',
            servings: '12 servings',
            date: 'December 2, 2025',
            imageUrl: 'https://sweetysbakery.com/images/IMG_0984.JPG',
            ingredients: [
                'Streusel: 1 cup Brown Sugar, 1 cup Flour, 1 tbsp Cinnamon, 1/2 cup cold Butter, cubed',
                'Cake: 2 cups Flour, 1 tsp Baking Powder, 1 tsp Baking Soda, 1/2 tsp Salt, 1/2 cup Butter, 1 cup Sugar, 2 Eggs, 1 cup Sour Cream'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease a 9x13 inch pan.',
                'Make the streusel: Combine brown sugar, flour, and cinnamon. Cut in the cold butter until the mixture resembles coarse crumbs.',
                'Make the cake: Whisk dry ingredients. Cream butter and sugar. Beat in eggs. Alternate adding dry ingredients and sour cream.',
                'Spread half the batter in the pan. Sprinkle with half the streusel.',
                'Top with remaining batter and then remaining streusel.',
                'Bake for 40-45 minutes.'
            ]
        }
    ],
    "Breads & Doughs": [
        {
            id: 'bread-no-knead',
            title: 'No-Knead Artisan Bread',
            description: 'A crusty, rustic loaf with an amazing open crumb, made with minimal effort.',
            prepTime: '10 min',
            cookTime: '45 min',
            servings: '1 loaf',
            date: 'December 3, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '3 cups (360g) All-Purpose or Bread Flour',
                '1 1/2 tsp Salt',
                '1/2 tsp Instant Yeast',
                '1 1/2 cups (360ml) Lukewarm Water'
            ],
            instructions: [
                'In a large bowl, mix all ingredients until a shaggy dough forms.',
                'Cover and let rest at room temperature for 12-18 hours.',
                'On a floured surface, gently shape the dough into a ball. Let rest for 30 minutes.',
                'Preheat a Dutch oven at 450°F (230°C) for 30 minutes.',
                'Carefully place dough in the hot Dutch oven. Bake covered for 30 minutes, then uncovered for 15 minutes.'
            ]
        },
        {
            id: 'bread-sourdough',
            title: 'Beginner Sourdough Bread',
            description: 'A basic but delicious guide to making your first sourdough loaf.',
            prepTime: '30 min',
            cookTime: '50 min',
            servings: '1 loaf',
            date: 'December 4, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '100g Active Sourdough Starter',
                '350g Warm Water',
                '500g Bread Flour',
                '10g Salt'
            ],
            instructions: [
                'Mix starter and water. Add flour and salt and mix to form a shaggy dough. Rest for 30 minutes (autolyse).',
                'Perform 3-4 sets of stretch-and-folds every 30 minutes over the next 2 hours.',
                'Let the dough bulk ferment until it has risen by about 30-50%.',
                'Shape the dough and place it in a proofing basket. Cold proof in the refrigerator for 12-18 hours.',
                'Preheat Dutch oven to 500°F (260°C). Bake covered for 20 minutes, then uncovered at 450°F (230°C) for 20-30 minutes.'
            ]
        },
        {
            id: 'bread-banana',
            title: 'Moist Banana Bread',
            description: 'The perfect one-bowl recipe to use up overripe bananas.',
            prepTime: '10 min',
            cookTime: '1 hr',
            servings: '1 loaf',
            date: 'December 5, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '3 very ripe Bananas, mashed',
                '1/2 cup (113g) Unsalted Butter, melted',
                '3/4 cup (165g) Brown Sugar',
                '1 large Egg, beaten',
                '1 tsp Vanilla Extract',
                '1 tsp Baking Soda',
                'Pinch of Salt',
                '1 1/2 cups (180g) All-Purpose Flour'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C). Grease a loaf pan.',
                'In a large bowl, mix mashed bananas, melted butter, sugar, egg, and vanilla.',
                'Sprinkle baking soda and salt over the mixture and stir. Add flour and mix until just combined.',
                'Pour into loaf pan and bake for 55-65 minutes.'
            ]
        },
        {
            id: 'dough-pizza',
            title: 'Homemade Pizza Dough',
            description: 'A simple, reliable dough for a crispy and chewy pizza crust.',
            prepTime: '15 min',
            cookTime: '12 min',
            servings: '2 12-inch pizzas',
            date: 'December 6, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1 1/2 cups (360ml) Warm Water',
                '2 1/4 tsp (1 packet) Instant Yeast',
                '1 tbsp Sugar',
                '2 tbsp Olive Oil',
                '1 tsp Salt',
                '3 1/2 cups (420g) All-Purpose Flour'
            ],
            instructions: [
                'Combine water, yeast, and sugar. Let sit for 5 minutes until foamy.',
                'Stir in oil and salt. Gradually add flour, mixing until a dough forms.',
                'Knead for 5-7 minutes until smooth. Place in a greased bowl, cover, and let rise for 1-2 hours, until doubled.',
                'Punch down dough, divide in two, and shape your pizza.',
                'Bake at 475°F (245°C) for 10-15 minutes.'
            ]
        },
        {
            id: 'dough-cinnamon-rolls',
            title: 'Fluffy Cinnamon Rolls',
            description: 'Soft, gooey cinnamon rolls with a rich cream cheese frosting.',
            prepTime: '30 min',
            cookTime: '25 min',
            servings: '12 rolls',
            date: 'December 7, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                'Dough: 1 cup Warm Milk, 2 1/4 tsp Yeast, 1/4 cup Sugar, 1 Egg, 1/4 cup Butter, 3 cups Flour, 1/2 tsp Salt',
                'Filling: 1/2 cup softened Butter, 3/4 cup Brown Sugar, 2 tbsp Cinnamon',
                'Frosting: 4 oz Cream Cheese, 1/4 cup Butter, 1 1/2 cups Powdered Sugar, 1/2 tsp Vanilla'
            ],
            instructions: [
                'Make the dough and let it rise for 1-2 hours.',
                'Roll the dough into a large rectangle. Spread with softened butter and sprinkle with cinnamon-sugar filling.',
                'Roll up tightly and slice into 12 rolls. Place in a greased pan and let rise for another 30-60 minutes.',
                'Bake at 375°F (190°C) for 20-25 minutes.',
                'While warm, spread with cream cheese frosting.'
            ]
        },
        {
            id: 'bread-brioche',
            title: 'Rich Brioche Loaf',
            description: 'A soft, tender, and buttery enriched bread.',
            prepTime: '25 min',
            cookTime: '35 min',
            servings: '1 loaf',
            date: 'December 8, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1/2 cup (120ml) Warm Milk',
                '2 1/4 tsp Yeast',
                '3 cups (360g) Bread Flour',
                '1/4 cup (50g) Sugar',
                '1 tsp Salt',
                '3 large Eggs',
                '1/2 cup (113g) Unsalted Butter, softened and cubed'
            ],
            instructions: [
                'Combine milk and yeast. Let sit for 5 minutes.',
                'In a stand mixer, combine flour, sugar, salt, eggs, and milk mixture. Mix until a dough forms.',
                'With the mixer on low, gradually add the softened butter, a few cubes at a time, until fully incorporated.',
                'Knead for 10-15 minutes until smooth and elastic. Let rise for 1-2 hours.',
                'Shape into a loaf, place in a greased loaf pan, and let rise again for 1 hour.',
                'Bake at 375°F (190°C) for 30-35 minutes.'
            ]
        },
        {
            id: 'bread-focaccia',
            title: 'Easy Focaccia Bread',
            description: 'A simple, dimpled Italian bread with a chewy texture and crispy crust.',
            prepTime: '15 min',
            cookTime: '25 min',
            servings: '12 servings',
            date: 'December 9, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '2 cups (480ml) Warm Water',
                '2 tsp Honey or Sugar',
                '2 1/4 tsp Yeast',
                '5 cups (600g) All-Purpose Flour',
                '2 tsp Salt',
                '1/4 cup Olive Oil, plus more for drizzling',
                'Flaky Sea Salt and Rosemary for topping'
            ],
            instructions: [
                'Combine water, honey, and yeast. Let sit for 5 minutes.',
                'In a large bowl, whisk flour and salt. Add yeast mixture and olive oil. Mix to form a very sticky dough.',
                'Cover and let rise for 1-2 hours.',
                'Pour dough into a well-oiled 9x13 inch pan. Gently stretch to fit.',
                'Dimple the dough with oiled fingers. Drizzle with more olive oil and sprinkle with sea salt and rosemary.',
                'Bake at 425°F (220°C) for 20-25 minutes until golden brown.'
            ]
        },
        {
            id: 'bread-challah',
            title: 'Classic Challah Bread',
            description: 'A soft, slightly sweet, and beautifully braided egg bread.',
            prepTime: '30 min',
            cookTime: '35 min',
            servings: '2 loaves',
            date: 'December 10, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1 1/2 cups Warm Water',
                '2 tsp Instant Yeast',
                '1/4 cup Honey',
                '1/4 cup Vegetable Oil',
                '2 large Eggs, plus 1 for egg wash',
                '1 tsp Salt',
                '4 1/2 cups (540g) All-Purpose Flour'
            ],
            instructions: [
                'Combine water, yeast, and honey. Let sit for 5 minutes.',
                'Whisk in oil and 2 eggs.',
                'In a large bowl, combine flour and salt. Add the wet ingredients and mix to form a dough.',
                'Knead for 8-10 minutes until smooth and elastic.',
                'Let rise in a greased bowl for 1-2 hours, until doubled.',
                'Divide dough, roll into strands, and braid. Let the braided loaves rise for another hour.',
                'Brush with egg wash and bake at 375°F (190°C) for 30-35 minutes.'
            ]
        },
        {
            id: 'bread-bagels',
            title: 'Homemade Bagels',
            description: 'Chewy, dense, and delicious bagels made right in your own kitchen.',
            prepTime: '30 min',
            cookTime: '25 min',
            servings: '8 bagels',
            date: 'December 1, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '2 tsp Instant Yeast',
                '1 1/2 cups Warm Water',
                '4 cups (480g) Bread Flour',
                '2 tbsp Sugar',
                '2 tsp Salt',
                '1 tbsp Barley Malt Syrup or Honey (for boiling)'
            ],
            instructions: [
                'Combine yeast and water. In a large bowl, mix flour, sugar, and salt. Add yeast mixture and form a stiff dough.',
                'Knead for 10 minutes until very smooth.',
                'Divide into 8 pieces, shape into balls, and let rest for 10 minutes.',
                'Shape the bagels by poking a hole in the center and stretching.',
                'Let bagels rise for 20 minutes. For a chewier bagel, refrigerate overnight at this stage.',
                'Preheat oven to 425°F (220°C). Bring a large pot of water to a boil and add malt syrup.',
                'Boil bagels for 1-2 minutes per side.',
                'Remove from water, top with desired toppings, and bake for 20-25 minutes until golden brown.'
            ]
        }
    ],
    "Pies & Tarts": [
        {
            id: 'pie-apple',
            title: 'Classic Apple Pie',
            description: 'A double-crust pie with a perfectly spiced apple filling.',
            prepTime: '45 min',
            cookTime: '1 hr',
            servings: '8 servings',
            date: 'December 2, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 recipe for a double-crust pie dough',
                '6-8 medium Apples, peeled and sliced',
                '3/4 cup (150g) Sugar',
                '2 tbsp All-Purpose Flour',
                '1 tsp Cinnamon',
                '1/4 tsp Nutmeg',
                '1 tbsp Lemon Juice',
                '2 tbsp Butter, cubed'
            ],
            instructions: [
                'Preheat oven to 425°F (220°C).',
                'Line a 9-inch pie plate with one crust.',
                'In a large bowl, toss apples with sugar, flour, spices, and lemon juice.',
                'Pour apple mixture into the crust and dot with butter.',
                'Cover with the top crust, seal the edges, and cut vents.',
                'Bake for 15 minutes, then reduce heat to 375°F (190°C) and bake for another 40-50 minutes.'
            ]
        },
        {
            id: 'pie-pumpkin',
            title: 'Creamy Pumpkin Pie',
            description: 'The quintessential fall dessert with a smooth, spiced custard filling.',
            prepTime: '15 min',
            cookTime: '50 min',
            servings: '8 servings',
            date: 'December 3, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 (9-inch) unbaked pie crust',
                '1 (15 oz) can Pumpkin Purée',
                '3/4 cup (150g) Sugar',
                '1/2 tsp Salt',
                '1 tsp Cinnamon',
                '1/2 tsp Ginger',
                '1/4 tsp Cloves',
                '2 large Eggs',
                '1 (12 oz) can Evaporated Milk'
            ],
            instructions: [
                'Preheat oven to 425°F (220°C).',
                'In a large bowl, mix pumpkin, sugar, salt, and spices.',
                'Beat in eggs. Gradually stir in evaporated milk.',
                'Pour into pie crust. Bake for 15 minutes.',
                'Reduce temperature to 350°F (175°C) and bake for 40-50 minutes more, until a knife inserted near the center comes out clean.'
            ]
        },
        {
            id: 'pie-pecan',
            title: 'Southern Pecan Pie',
            description: 'A sweet and gooey pie loaded with toasted pecans.',
            prepTime: '15 min',
            cookTime: '1 hr',
            servings: '8 servings',
            date: 'December 4, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 (9-inch) unbaked pie crust',
                '1 cup Light Corn Syrup',
                '3 large Eggs',
                '1/2 cup (100g) Sugar',
                '2 tbsp Melted Butter',
                '1 tsp Vanilla Extract',
                '1 1/2 cups (170g) Pecan Halves'
            ],
            instructions: [
                'Preheat oven to 350°F (175°C).',
                'In a large bowl, whisk corn syrup, eggs, sugar, butter, and vanilla until well blended.',
                'Stir in pecans.',
                'Pour filling into the unbaked pie crust.',
                'Bake for 60-70 minutes, until the center is set.'
            ]
        },
        {
            id: 'pie-key-lime',
            title: 'Key Lime Pie',
            description: 'A tangy and creamy pie with a graham cracker crust.',
            prepTime: '20 min',
            cookTime: '15 min',
            servings: '8 servings',
            date: 'December 5, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                'Crust: 1 1/2 cups Graham Cracker Crumbs, 6 tbsp Melted Butter',
                'Filling: 4 Egg Yolks, 1 (14 oz) can Sweetened Condensed Milk, 1/2 cup Key Lime Juice'
            ],
            instructions: [
                'Preheat oven to 375°F (190°C).',
                'Mix crust ingredients and press into a 9-inch pie plate. Bake for 10 minutes.',
                'Whisk egg yolks and condensed milk. Gradually whisk in key lime juice.',
                'Pour into crust and bake for 15 minutes.',
                'Chill for at least 3 hours before serving.'
            ]
        },
        {
            id: 'tart-fruit',
            title: 'Classic Fruit Tart',
            description: 'A buttery crust, creamy pastry cream, and fresh, colorful fruit.',
            prepTime: '1 hr',
            cookTime: '25 min',
            servings: '8 servings',
            date: 'December 6, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 recipe Pâte Sablée (sweet shortcrust pastry)',
                '1 recipe Pastry Cream',
                'Assorted fresh fruit (berries, kiwi, etc.)',
                '1/4 cup Apricot Jam, for glaze'
            ],
            instructions: [
                'Press the Pâte Sablée into a tart pan with a removable bottom. Prick with a fork and chill for 30 minutes.',
                'Blind bake the crust at 375°F (190°C) for 20-25 minutes, until golden.',
                'Let the crust cool completely. Spread the pastry cream evenly inside.',
                'Arrange fresh fruit on top of the pastry cream.',
                'Warm the apricot jam with a little water and brush over the fruit to glaze.'
            ]
        },
        {
            id: 'pie-lemon-meringue',
            title: 'Lemon Meringue Pie',
            description: 'A showstopping dessert with a flaky crust, tangy lemon filling, and a mountain of toasted meringue.',
            prepTime: '40 min',
            cookTime: '30 min',
            servings: '8 servings',
            date: 'December 7, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 (9-inch) pre-baked pie crust',
                'Filling: 1 1/2 cups Sugar, 1/4 cup Cornstarch, 1 1/2 cups Water, 4 Egg Yolks, 3 tbsp Butter, 1/2 cup Lemon Juice',
                'Meringue: 4 Egg Whites, 1/4 tsp Cream of Tartar, 1/2 cup Sugar'
            ],
            instructions: [
                'For filling, combine sugar and cornstarch in a saucepan. Gradually whisk in water.',
                'Cook over medium heat, stirring constantly, until mixture boils and thickens.',
                'In a small bowl, lightly beat egg yolks. Whisk a small amount of the hot sugar mixture into the yolks, then pour the yolk mixture back into the saucepan.',
                'Bring to a boil and cook for 2 minutes. Remove from heat and stir in butter and lemon juice.',
                'Pour hot filling into the baked pie crust.',
                'For meringue, beat egg whites and cream of tartar until soft peaks form. Gradually add sugar and beat until stiff, glossy peaks form.',
                'Spread meringue over the hot filling, ensuring it touches the crust all around to prevent shrinking.',
                'Bake at 350°F (175°C) for 10-15 minutes, until meringue is golden brown. Cool completely.'
            ]
        }
    ],
    "Pastries & Desserts": [
        {
            id: 'pastry-croissants',
            title: 'Classic Croissants',
            description: 'A challenging but rewarding project to create flaky, buttery, laminated dough.',
            prepTime: '4 hrs',
            cookTime: '20 min',
            servings: '12 croissants',
            date: 'December 8, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '4 cups (480g) Bread Flour',
                '1/4 cup (50g) Sugar',
                '2 tsp Salt',
                '2 1/4 tsp Instant Yeast',
                '1 1/4 cups (300ml) Lukewarm Milk',
                '1 cup (227g) Unsalted Butter, cold (for lamination)'
            ],
            instructions: [
                'Make the dough (détrempe) and let it rest.',
                'Create a butter block (beurrage).',
                'Laminate the dough by enclosing the butter and performing a series of "turns" (folds), chilling between each turn.',
                'Shape the croissants, let them proof until puffy.',
                'Bake at 400°F (200°C) for 15-20 minutes until deeply golden brown.'
            ]
        },
        {
            id: 'pastry-macarons',
            title: 'French Macarons',
            description: 'Delicate almond meringue cookies with a crisp shell and chewy interior.',
            prepTime: '45 min',
            cookTime: '15 min',
            servings: '30 shells',
            date: 'December 9, 2025',
            imageUrl: '/images/blog/cookies.png',
            ingredients: [
                '1 cup (120g) Almond Flour, sifted',
                '1 cup (120g) Powdered Sugar, sifted',
                '3 large Egg Whites, room temperature',
                '1/4 cup (50g) Granulated Sugar',
                'Pinch of Cream of Tartar'
            ],
            instructions: [
                'Whisk almond flour and powdered sugar together.',
                'Beat egg whites and cream of tartar until foamy. Gradually add granulated sugar and beat until stiff, glossy peaks form.',
                'Fold the dry ingredients into the meringue in stages until the batter flows like lava (macaronage).',
                'Pipe onto baking sheets and let rest for 30-60 minutes until a skin forms.',
                'Bake at 300°F (150°C) for 15-18 minutes.'
            ]
        },
        {
            id: 'dessert-tiramisu',
            title: 'Classic Tiramisu',
            description: 'A no-bake Italian dessert with coffee-soaked ladyfingers and mascarpone cream.',
            prepTime: '30 min',
            cookTime: '0 min',
            servings: '8 servings',
            date: 'December 10, 2025',
            imageUrl: '/images/blog/chocolate-cake.png',
            ingredients: [
                '6 Egg Yolks',
                '3/4 cup (150g) Sugar',
                '1 lb (450g) Mascarpone Cheese',
                '1 1/2 cups Strong Brewed Coffee, cooled',
                '24 Ladyfingers (Savoiardi)',
                'Unsweetened Cocoa Powder, for dusting'
            ],
            instructions: [
                'Whisk egg yolks and sugar over a double boiler until pale and thick.',
                'Let cool, then gently fold in the mascarpone cheese.',
                'Quickly dip ladyfingers in coffee and arrange a layer in a dish.',
                'Spread half of the mascarpone mixture over the ladyfingers.',
                'Repeat with another layer of ladyfingers and mascarpone.',
                'Chill for at least 4 hours. Dust with cocoa powder before serving.'
            ]
        },
        {
            id: 'dessert-creme-brulee',
            title: 'Crème Brûlée',
            description: 'A rich custard base with a contrasting layer of hard caramel.',
            prepTime: '15 min',
            cookTime: '40 min',
            servings: '6 servings',
            date: 'December 1, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '2 cups (480ml) Heavy Cream',
                '1 Vanilla Bean, split, or 1 tsp Vanilla Extract',
                '5 large Egg Yolks',
                '1/2 cup (100g) Sugar, plus more for topping'
            ],
            instructions: [
                'Preheat oven to 325°F (165°C).',
                'Heat cream and vanilla bean until just simmering. Remove from heat and let steep for 15 minutes.',
                'Whisk egg yolks and sugar until pale. Slowly temper the hot cream into the egg mixture.',
                'Strain the custard and pour into ramekins. Place in a water bath.',
                'Bake for 30-40 minutes until the center is just set.',
                'Chill for at least 2 hours. Before serving, sprinkle with sugar and caramelize with a torch.'
            ]
        },
        {
            id: 'pastry-eclairs',
            title: 'Chocolate Éclairs',
            description: 'Choux pastry filled with pastry cream and topped with chocolate glaze.',
            prepTime: '45 min',
            cookTime: '35 min',
            servings: '12 éclairs',
            date: 'December 2, 2025',
            imageUrl: '/images/blog/chocolate-cake.png',
            ingredients: [
                '1 recipe Pâte à Choux',
                '1 recipe Pastry Cream',
                '1 recipe Chocolate Glaze'
            ],
            instructions: [
                'Preheat oven to 400°F (200°C).',
                'Pipe the choux pastry into 4-inch logs on a baking sheet.',
                'Bake for 15 minutes, then reduce heat to 350°F (175°C) and bake for another 20 minutes until golden and hollow.',
                'Let cool completely. Poke holes in the bottom and fill with pastry cream.',
                'Dip the tops in chocolate glaze.'
            ]
        },
        {
            id: 'dessert-souffle',
            title: 'Chocolate Soufflé',
            description: 'A light and airy baked egg dessert that rises dramatically.',
            prepTime: '25 min',
            cookTime: '15 min',
            servings: '4 servings',
            date: 'December 3, 2025',
            imageUrl: '/images/blog/chocolate-cake.png',
            ingredients: [
                '4 oz Bittersweet Chocolate, chopped',
                '3 large Egg Yolks',
                '5 large Egg Whites',
                '1/4 cup (50g) Sugar',
                'Pinch of Cream of Tartar'
            ],
            instructions: [
                'Preheat oven to 400°F (200°C). Butter and sugar four ramekins.',
                'Melt chocolate over a double boiler. Let cool slightly, then whisk in egg yolks.',
                'In a clean bowl, beat egg whites and cream of tartar until soft peaks form. Gradually add sugar and beat to stiff peaks.',
                'Gently fold one-third of the meringue into the chocolate mixture to lighten it, then fold in the rest.',
                'Divide among ramekins and bake for 12-15 minutes. Serve immediately.'
            ]
        },
        {
            id: 'dessert-panna-cotta',
            title: 'Vanilla Bean Panna Cotta',
            description: 'A simple and elegant Italian dessert of sweetened cream set with gelatin.',
            prepTime: '10 min',
            cookTime: '5 min',
            servings: '6 servings',
            date: 'December 4, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 1/2 tsp (1 packet) Unflavored Gelatin',
                '2 tbsp Cold Water',
                '3 cups Heavy Cream',
                '1/2 cup (100g) Granulated Sugar',
                '1 Vanilla Bean, split, or 1 tsp Vanilla Extract'
            ],
            instructions: [
                'In a small bowl, sprinkle gelatin over cold water and let it bloom for 5 minutes.',
                'In a saucepan, heat heavy cream, sugar, and vanilla bean until simmering. Do not boil.',
                'Remove from heat, scrape the seeds from the vanilla bean into the cream, and discard the pod.',
                'Whisk in the bloomed gelatin until it is completely dissolved.',
                'Pour the mixture into 6 ramekins or glasses.',
                'Chill for at least 4 hours, or until set. Serve with fresh berries or a fruit coulis.'
            ]
        }
    ],
    "Frostings & Fillings": [
        {
            id: 'frosting-american-buttercream',
            title: 'American Buttercream',
            description: 'A simple, sweet, and popular frosting made from butter and powdered sugar.',
            prepTime: '10 min',
            cookTime: '0 min',
            servings: 'Frosts 12 cupcakes',
            date: 'December 5, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1 cup (227g) Unsalted Butter, softened',
                '3-4 cups (360-480g) Powdered Sugar, sifted',
                '1/4 cup (60ml) Heavy Cream or Milk',
                '1 tsp Vanilla Extract',
                'Pinch of Salt'
            ],
            instructions: [
                'In a large bowl, beat the softened butter until creamy.',
                'Gradually add the powdered sugar, one cup at a time, mixing on low speed until combined, then on high speed.',
                'Add the vanilla and salt. Pour in the cream and beat on high speed for 3-5 minutes until light and fluffy.'
            ]
        },
        {
            id: 'frosting-swiss-meringue',
            title: 'Swiss Meringue Buttercream',
            description: 'A silky, stable, and less-sweet buttercream perfect for professional finishes.',
            prepTime: '25 min',
            cookTime: '10 min',
            servings: 'Frosts a 3-layer 8" cake',
            date: 'December 6, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '5 large Egg Whites',
                '1 1/2 cups (300g) Granulated Sugar',
                '2 cups (454g) Unsalted Butter, room temperature, cubed',
                '2 tsp Vanilla Extract',
                'Pinch of Salt'
            ],
            instructions: [
                'Whisk egg whites and sugar in a heatproof bowl over a pot of simmering water (double boiler).',
                'Whisk constantly until the mixture reaches 160°F (71°C) and sugar is dissolved.',
                'Transfer to a stand mixer and whip on high speed until a stiff, glossy meringue forms and the bowl is cool to the touch.',
                'Switch to the paddle attachment. On low speed, add the butter one cube at a time.',
                'Once all butter is added, increase speed to medium-high and beat until the buttercream comes together and is silky smooth (it may curdle first - this is normal).'
            ]
        },
        {
            id: 'frosting-cream-cheese',
            title: 'Cream Cheese Frosting',
            description: 'The classic tangy and sweet frosting for carrot cake and red velvet.',
            prepTime: '10 min',
            cookTime: '0 min',
            servings: 'Frosts a 9x13" cake',
            date: 'December 7, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '8 oz (226g) Cream Cheese, softened',
                '1/2 cup (113g) Unsalted Butter, softened',
                '4 cups (480g) Powdered Sugar, sifted',
                '1 tsp Vanilla Extract'
            ],
            instructions: [
                'In a large bowl, beat the cream cheese and butter until smooth and creamy.',
                'Gradually add the powdered sugar and mix on low speed until combined, then high speed until smooth.',
                'Stir in the vanilla extract.'
            ]
        },
        {
            id: 'filling-pastry-cream',
            title: 'Pastry Cream (Crème Pâtissière)',
            description: 'A rich, creamy custard used for filling éclairs, tarts, and donuts.',
            prepTime: '10 min',
            cookTime: '15 min',
            servings: '2 cups',
            date: 'December 8, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '2 cups (480ml) Whole Milk',
                '1/2 cup (100g) Sugar',
                '1/4 cup (30g) Cornstarch',
                'Pinch of Salt',
                '4 large Egg Yolks',
                '2 tbsp Unsalted Butter',
                '1 tsp Vanilla Extract'
            ],
            instructions: [
                'Heat milk in a saucepan until it begins to simmer.',
                'In a bowl, whisk together sugar, cornstarch, salt, and egg yolks.',
                'Slowly temper the hot milk into the egg mixture, whisking constantly.',
                'Return the entire mixture to the saucepan and cook over medium heat, whisking constantly, until it thickens and boils.',
                'Boil for 1 minute, then remove from heat. Stir in butter and vanilla.',
                'Press plastic wrap directly onto the surface and chill for at least 2 hours.'
            ]
        },
        {
            id: 'filling-lemon-curd',
            title: 'Lemon Curd',
            description: 'A tangy, sweet, and bright filling for tarts, cakes, and scones.',
            prepTime: '5 min',
            cookTime: '10 min',
            servings: '1 1/2 cups',
            date: 'December 9, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '3 large Eggs',
                '1 cup (200g) Sugar',
                '1/2 cup (120ml) Fresh Lemon Juice',
                'Zest of 2 Lemons',
                '1/2 cup (113g) Unsalted Butter, cubed'
            ],
            instructions: [
                'In a saucepan, whisk together eggs, sugar, lemon juice, and zest.',
                'Cook over medium-low heat, whisking constantly, until the mixture thickens enough to coat the back of a spoon (about 10 minutes). Do not boil.',
                'Remove from heat and stir in the butter until melted and smooth.',
                'Strain through a fine-mesh sieve into a bowl. Press plastic wrap onto the surface and chill.'
            ]
        },
        {
            id: 'frosting-ganache',
            title: 'Chocolate Ganache',
            description: 'A versatile mixture of chocolate and cream for drips, fillings, or frosting.',
            prepTime: '5 min',
            cookTime: '5 min',
            servings: 'Covers one 8" cake',
            date: 'December 10, 2025',
            imageUrl: '/images/blog/chocolate-cake.png',
            ingredients: [
                '8 oz (225g) Semi-Sweet Chocolate, finely chopped',
                '1 cup (240ml) Heavy Cream'
            ],
            instructions: [
                'Place the chopped chocolate in a heatproof bowl.',
                'Heat the heavy cream in a saucepan until it just begins to simmer.',
                'Pour the hot cream over the chocolate and let it sit for 5 minutes without stirring.',
                'Gently stir from the center outwards until the ganache is smooth and glossy.',
                'Let it cool to the desired consistency. Cool at room temperature for a spreadable frosting, or use while warm for a drip.'
            ]
        },
        {
            id: 'frosting-ermine',
            title: 'Ermine Frosting (Cooked Flour Frosting)',
            description: 'A silky, old-fashioned frosting that is less sweet than American buttercream. The traditional topping for Red Velvet Cake.',
            prepTime: '15 min',
            cookTime: '10 min',
            servings: 'Frosts a 2-layer 9" cake',
            date: 'December 1, 2025',
            imageUrl: '/images/blog/baking-ingredients.png',
            ingredients: [
                '1/4 cup (30g) All-Purpose Flour',
                '1 cup (240ml) Whole Milk',
                '1 cup (227g) Unsalted Butter, softened',
                '1 cup (200g) Granulated Sugar',
                '1 tsp Vanilla Extract'
            ],
            instructions: [
                'In a saucepan, whisk flour and milk until smooth. Cook over medium heat, whisking constantly, until it becomes a very thick paste (like pudding).',
                'Transfer the paste to a bowl, press plastic wrap on the surface, and cool completely to room temperature.',
                'In a separate bowl, beat the butter and sugar for 5-7 minutes until extremely light and fluffy, and the sugar has mostly dissolved.',
                'With the mixer on low, add the cooled flour paste to the butter mixture one spoonful at a time.',
                'Once all paste is added, add vanilla and beat on high speed for another 5 minutes until it resembles whipped cream.'
            ]
        },
    ],
    "Savory Bakes": [
        {
            id: 'savory-quiche-lorraine',
            title: 'Quiche Lorraine',
            description: 'A classic French tart with a bacon, egg, and cheese custard filling.',
            prepTime: '20 min',
            cookTime: '45 min',
            servings: '6 servings',
            date: 'December 2, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1 (9-inch) unbaked pie crust',
                '6 slices Bacon, cooked and crumbled',
                '1 cup (115g) Gruyère Cheese, shredded',
                '3 large Eggs',
                '1 1/2 cups (360ml) Heavy Cream',
                '1/4 tsp Salt',
                'Pinch of Nutmeg'
            ],
            instructions: [
                'Preheat oven to 375°F (190°C). Blind bake the pie crust for 15 minutes.',
                'Sprinkle the cooked bacon and shredded cheese into the bottom of the crust.',
                'In a bowl, whisk eggs, cream, salt, and nutmeg.',
                'Carefully pour the egg mixture over the bacon and cheese.',
                'Bake for 30-35 minutes, until the center is just set.'
            ]
        },
        {
            id: 'savory-sausage-rolls',
            title: 'British Sausage Rolls',
            description: 'Seasoned sausage meat wrapped in flaky puff pastry.',
            prepTime: '15 min',
            cookTime: '25 min',
            servings: '12 rolls',
            date: 'December 3, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1 lb (450g) Pork Sausage Meat',
                '1 sheet (approx. 10x15 inches) Puff Pastry, thawed',
                '1 Egg, beaten (for egg wash)'
            ],
            instructions: [
                'Preheat oven to 400°F (200°C).',
                'Unroll the puff pastry sheet and cut it in half lengthwise to create two long rectangles.',
                'Divide the sausage meat in half and form each half into a long log down the center of each pastry rectangle.',
                'Brush one long edge of the pastry with egg wash. Fold the other side over and press to seal.',
                'Cut each log into 6 individual rolls. Brush the tops with egg wash and cut small slits.',
                'Bake for 20-25 minutes until golden brown and puffed.'
            ]
        },
        {
            id: 'savory-chicken-pot-pie',
            title: 'Chicken Pot Pie',
            description: 'A creamy chicken and vegetable filling topped with a flaky crust.',
            prepTime: '30 min',
            cookTime: '40 min',
            servings: '6 servings',
            date: 'December 4, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '1 recipe for a single-crust pie dough',
                '1/3 cup Butter',
                '1/3 cup Chopped Onion',
                '1/3 cup All-Purpose Flour',
                '1 3/4 cups Chicken Broth',
                '1/2 cup Milk',
                '2 cups Cooked Chicken, shredded',
                '2 cups Mixed Vegetables (peas, carrots, corn)'
            ],
            instructions: [
                'Preheat oven to 425°F (220°C).',
                'In a saucepan, melt butter and sauté onion. Stir in flour to make a roux.',
                'Gradually whisk in broth and milk. Cook until thickened.',
                'Stir in chicken and vegetables. Pour into a pie dish.',
                'Top with pie crust, seal edges, and cut vents.',
                'Bake for 35-40 minutes until crust is golden and filling is bubbly.'
            ]
        },
        {
            id: 'bread-cornbread',
            title: 'Southern-Style Cornbread',
            description: 'A savory, crumbly cornbread with a crisp crust from a cast-iron skillet.',
            prepTime: '10 min',
            cookTime: '25 min',
            servings: '8 servings',
            date: 'December 5, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '2 tbsp Bacon Drippings or Vegetable Oil',
                '2 cups (240g) Self-Rising Cornmeal Mix',
                '2 large Eggs',
                '1 1/2 cups (360ml) Buttermilk'
            ],
            instructions: [
                'Place bacon drippings in a 10-inch cast-iron skillet and place in the oven. Preheat oven to 425°F (220°C).',
                'In a bowl, whisk together cornmeal mix, eggs, and buttermilk until just combined.',
                'Carefully remove the hot skillet from the oven. Pour the batter into the sizzling hot skillet.',
                'Bake for 20-25 minutes, until golden brown and a toothpick comes out clean.'
            ]
        },
        {
            id: 'savory-scones',
            title: 'Cheddar and Chive Scones',
            description: 'Flaky, buttery, and savory scones packed with sharp cheddar cheese and fresh chives.',
            prepTime: '15 min',
            cookTime: '15 min',
            servings: '8 scones',
            date: 'December 6, 2025',
            imageUrl: '/images/blog/bread.png',
            ingredients: [
                '2 cups (240g) All-Purpose Flour',
                '1 tbsp Baking Powder',
                '1/2 tsp Salt',
                '1/2 cup (113g) Cold Unsalted Butter, cubed',
                '1 cup (115g) Shredded Sharp Cheddar Cheese',
                '2 tbsp Chopped Fresh Chives',
                '3/4 cup (180ml) Heavy Cream or Buttermilk'
            ],
            instructions: [
                'Preheat oven to 400°F (200°C).',
                'Whisk together flour, baking powder, and salt. Cut in the cold butter until the mixture resembles coarse crumbs.',
                'Stir in the cheddar cheese and chives.',
                'Gradually add the cream, mixing until a shaggy dough forms.',
                'Pat the dough into a circle and cut into 8 wedges. Brush with a little cream.',
                'Bake for 12-15 minutes until golden brown.'
            ]
        },
    ]
};


